export default __webpack_public_path__ + "static/media/christmas_high.40cac4e1.png";